import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMenuItems } from "../assets/js/content";
import { getRightContent, setAdditionalClasses } from "../assets/js/utils";
import { changeSection } from "../store/auxiliary/ui/sections";

function NavbarList({ onPressMenuItem, isSticky }) {
  const dispatch = useDispatch();
  const sections = useSelector((state) => state.ui.sections);
  const generalSetings = useSelector((state) => state.ui.generalSettings);
  return (
    <ul
      className={`navbar-list${setAdditionalClasses(
        ["navbar-left-padded"],
        [!isSticky]
      )}`}
    >
      {getMenuItems().map(
        (menu) =>
          menu.position > 0 && (
            <li
              key={menu.position}
              className={`navbar-list__item${setAdditionalClasses(
                ["active"],
                [sections.currentSection === menu.position]
              )}`}
              onClick={() =>
                menu.position !== sections.currentSection &&
                onPressMenuItem(menu.position)
              }
            >
              {getRightContent(generalSetings.rtlLanguage, menu.label)}
            </li>
          )
      )}
    </ul>
  );
}

export default NavbarList;
